var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { LoadingStatePerks, ErrorStatePerks, RenderAvailableAndUnlocked, RenderPlcc, RenderWellDone, RenderUntilNextPerk, } from './PerkCardStates';
import { InfoPerksContext, RewardsHubContext, RewardsAndOffersContext, PerkProgressProvider, DrawerContext, } from '../../../../contexts';
import { getPLCCAccrualData } from '../../../Utils';
var determinePerkStatus = function (props) {
    var rewardsAndOffers = props.rewardsAndOffers, isPacDrawersEnabled = props.isPacDrawersEnabled;
    var _a = rewardsAndOffers || {}, perkAccrualSummary = _a.perkAccrualSummary, customerInfo = _a.customerInfo;
    var pxccUserCategory = (customerInfo || {}).pxccUserCategory;
    var _b = perkAccrualSummary || {}, unclaimedPerksCount = _b.unclaimedPerksCount, activePerksCount = _b.activePerksCount;
    var finalTierPerkAchieved = getPLCCAccrualData(perkAccrualSummary).finalTierPerkAchieved;
    var isEnrolledInPxcc = pxccUserCategory === 'Enrolled';
    var isMaxedOut = finalTierPerkAchieved && !activePerksCount && unclaimedPerksCount < 1;
    if (isMaxedOut && !isPacDrawersEnabled)
        return 'RenderWellDone';
    if (activePerksCount || unclaimedPerksCount > 0)
        return 'RenderAvailableAndUnlocked';
    if (!finalTierPerkAchieved && isEnrolledInPxcc)
        return 'RenderPlcc';
    if (!finalTierPerkAchieved && !isEnrolledInPxcc)
        return 'RenderUntilNextPerk';
    return '';
};
var HasDataStatePerks = function () {
    var rewardsAndOffers = React.useContext(RewardsAndOffersContext).rewardsAndOffers;
    var isPacDrawersEnabled = React.useContext(DrawerContext).isPacDrawersEnabled;
    var perkStatus = determinePerkStatus({
        rewardsAndOffers: rewardsAndOffers,
        isPacDrawersEnabled: isPacDrawersEnabled,
    });
    var RenderPerksState = function () { return React.createElement(React.Fragment, null); };
    switch (perkStatus) {
        case 'RenderWellDone':
            RenderPerksState = isPacDrawersEnabled
                ? RenderAvailableAndUnlocked
                : RenderWellDone;
            break;
        case 'RenderPlcc':
            RenderPerksState = RenderPlcc;
            break;
        case 'RenderUntilNextPerk':
            RenderPerksState = isPacDrawersEnabled
                ? RenderAvailableAndUnlocked
                : RenderUntilNextPerk;
            break;
        case 'RenderAvailableAndUnlocked':
        default:
            RenderPerksState = RenderAvailableAndUnlocked;
    }
    return React.createElement(RenderPerksState, null);
    // // Local testing
    // return <RenderWellDone />;
    // return <RenderAvailableAndUnlocked />;
    // return <RenderPlcc />;
    // return <RenderUntilNextPerk />;
};
var RenderPerkRewards = React.memo(function (props) {
    var isMobile = props.isMobile, isLoading = props.isLoading, hasError = props.hasError;
    var isCardLoading = isLoading;
    var hasCardError = !isCardLoading && hasError;
    return React.useMemo(function () {
        if (isCardLoading)
            return React.createElement(LoadingStatePerks, null);
        if (hasCardError)
            return React.createElement(ErrorStatePerks, null);
        return React.createElement(HasDataStatePerks, null);
    }, [isMobile, isLoading]);
});
export var PerkRewards = function (_a) {
    var isMobile = _a.isMobile, _b = _a.autoFetch, autoFetch = _b === void 0 ? true : _b;
    var _c = React.useContext(InfoPerksContext), isLoading = _c.isLoading, hasError = _c.hasError, getPerksInfoPerksData = _c.getPerksInfoPerksData, perksInfo = _c.perksInfo;
    var isPageLoaded = React.useContext(RewardsHubContext).isPageLoaded;
    React.useEffect(function () {
        var apiControllerIP = new AbortController();
        if (autoFetch && isPageLoaded && isLoading)
            getPerksInfoPerksData({ signal: apiControllerIP.signal });
        return function () {
            apiControllerIP.abort();
        };
    }, [isLoading, autoFetch]);
    return (React.createElement(PerkProgressProvider, { perksInfo: perksInfo },
        React.createElement(RenderPerkRewards, __assign({}, { isMobile: isMobile, isLoading: isLoading, hasError: hasError }))));
};
